const iconSet = {
  IcoMoonType: "selection",
  icons: [
    {
      icon: {
        paths: [
          "M512 96c-111.118 0-215.584 43.272-294.156 121.844s-121.844 183.038-121.844 294.156c0 111.118 43.272 " +
            "215.584 121.844 294.156s183.038 121.844 294.156 121.844c111.118 0 215.584-43.272 294.156-121." +
            "844s121.844-183.038 121.844-294.156c0-111.118-43.272-215.584-121.844-294.156s-183.038-121.844-" +
            "294.156-121.844zM512 0v0c282.77 0 512 229.23 512 512s-229.23 512-512 512c-282.77 0-512-229.23-" +
            "512-512s229.23-512 512-512zM448 704h128v128h-128zM448 192h128v384h-128z"
        ],
        tags: ["notification", "warning", "notice", "note", "exclamation"],
        defaultCode: 59912,
        grid: 16,
        attrs: []
      },
      attrs: [],
      properties: {
        ligatures: "notification, warning2",
        name: "warning",
        order: 4,
        id: 265,
        prevSize: 32
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 264
    },
    {
      icon: {
        paths: [
          "M448 304c0-26.4 21.6-48 48-48h32c26.4 0 48 21.6 48 48v32c0 26.4-21.6 48-48 48h-32c-26.4" +
            " 0-48-21.6-48-48v-32z",
          "M640 768h-256v-64h64v-192h-64v-64h192v256h64z",
          "M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512" +
            " 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z"
        ],
        tags: ["info", "information"],
        defaultCode: 59916,
        grid: 16,
        attrs: []
      },
      attrs: [],
      properties: {
        ligatures: "info, information",
        name: "info",
        order: 3,
        id: 269,
        prevSize: 32
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 268
    },
    {
      icon: {
        paths: [
          "M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 " +
            "928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z",
          "M672 256l-160 160-160-160-96 96 160 160-160 160 96 96 160-160 160 160 96-96-160-160 160-160z"
        ],
        tags: ["cancel-circle", "close", "remove", "delete"],
        defaultCode: 59917,
        grid: 16,
        attrs: []
      },
      attrs: [],
      properties: {
        ligatures: "cancel-circle, close",
        name: "error",
        order: 2,
        id: 270,
        prevSize: 32
      },
      setIdx: 0,
      setId: 1,
      iconIdx: 269
    },
    {
      icon: {
        paths: [
          "M512 439.603l-362.035-362.035-72.397 72.397 362.035 362.035-362.035 362.035 72.397 72.397 " +
            "362.035-362.035 362.035 362.035 72.397-72.397-362.035-362.035 362.035-362.035-72.397-72." +
            "397-362.035 362.035z"
        ],
        attrs: [{}],
        isMulticolor: false,
        isMulticolor2: false,
        tags: ["close"],
        grid: 20
      },
      attrs: [{}],
      properties: {
        order: 1,
        id: 1,
        prevSize: 20,
        name: "close"
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M150.016 873.984c-96.436-93.233-156.308-223.762-156.308-368.276 0-282.77 229.23-512 512-512 " +
            "144.514 0 275.043 59.872 368.137 156.164l0.138 0.144c88.925 91.979 143.724 217.436 143.724 " +
            "355.692 0 282.77-229.23 512-512 512-138.256 0-263.713-54.799-355.836-143.863l0.144 " +
            "0.138zM801.792 801.792c74.164-74.164 120.036-176.621 120.036-289.792 0-226.342-183.486-409.828-" +
            "409.828-409.828-113.171 0-215.628 45.872-289.792 120.036v0c-74.164 74.164-120.036 176.621-120" +
            ".036 289.792 0 226.342 183.486 409.828 409.828 409.828 113.171 0 215.628-45.872 289.792-120" +
            ".036v0zM343.040 475.648l117.76 118.272 220.16-220.16 71.68 72.704-291.84 290.816-189.44-189.44 " +
            "71.68-72.704z"
        ],
        attrs: [{}],
        isMulticolor: false,
        isMulticolor2: false,
        tags: ["checkmark-outline"],
        grid: 20
      },
      attrs: [{}],
      properties: {
        order: 1,
        id: 0,
        prevSize: 20,
        name: "success"
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 1
    },
    {
      icon: {
        paths: [
          "M512.051 399.36c-62.208 0-112.691 50.432-112.691 112.64s50.483 112.64 112.691 " +
            "112.64c62.208 0 112.589-50.432 112.589-112.64s-50.381-112.64-112.589-112.64zM512.051 " +
            "266.24c62.208 0 112.589-50.483 112.589-112.64s-50.381-112.64-112.589-112.64c-62.208 " +
            "0-112.691 50.432-112.691 112.64s50.483 112.64 112.691 112.64zM512.051 757.76c-62.208 " +
            "0-112.691 50.432-112.691 112.64s50.483 112.64 112.691 112.64c62.208 0 112.589-50.432 " +
            "112.589-112.64s-50.381-112.64-112.589-112.64z"
        ],
        attrs: [{}],
        isMulticolor: false,
        isMulticolor2: false,
        tags: ["dots-three-vertical"],
        grid: 20
      },
      attrs: [{}],
      properties: {
        order: 2,
        id: 0,
        prevSize: 20,
        name: "dots-three-vertical"
      },
      setIdx: 0,
      setId: 2,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M678.4 512l-365.619-379.904c-13.722-13.824-13.722-36.198 0-50.125 13.722-13.824 35.891-13.824 49.613" +
            " 0l400.896 404.89c13.722 13.875 13.722 36.301 0 50.125l-400.896 404.89c-13.722 13.875-35.891 " +
            "13.824-49.613 0-13.722-13.773-13.722-36.198 0-50.125l365.619-379.75z"
        ],
        attrs: [{}],
        isMulticolor: false,
        isMulticolor2: false,
        tags: ["chevron-right"],
        grid: 20
      },
      attrs: [{}],
      properties: {
        order: 1,
        id: 0,
        prevSize: 20,
        name: "chevron-right"
      },
      setIdx: 0,
      setId: 3,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M563.2 460.8h204.8v102.4h-204.8v204.8h-102.4v-204.8h-204.8v-102.4h204.8v-204.8h102.4v204.8zM512 " +
            "1024c-282.77 0-512-229.23-512-512s229.23-512 512-512v0c282.77 0 512 229.23 512 512s-229.23 512-512 " +
            "512v0zM512 921.6c226.216 0 409.6-183.384 409.6-409.6s-183.384-409.6-409.6-409.6v0c-226.216 0-409.6" +
            " 183.384-409.6 409.6s183.384 409.6 409.6 409.6v0z"
        ],
        attrs: [{}],
        isMulticolor: false,
        isMulticolor2: false,
        tags: ["add", "add-outline"],
        grid: 20
      },
      attrs: [{}],
      properties: {
        order: 1,
        id: 2,
        prevSize: 20,
        name: "add"
      },
      setIdx: 1,
      setId: 2,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M992.262 871.396l-242.552-206.294c-25.074-22.566-51.89-32.926-73.552-31.926 57.256-67.068 91.842-154.078 " +
            "91.842-249.176 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.922 384 384 384c95.098 0 " +
            "182.108-34.586 249.176-91.844-1 21.662 9.36 48.478 31.926 73.552l206.294 242.552c35.322 39.246 93.022 " +
            "42.554 128.22 7.356s31.892-92.898-7.354-128.22zM384 640c-141.384 0-256-114.616-256-256s114.616-256 " +
            "256-256 256 114.616 256 256-114.614 256-256 256z"
        ],
        tags: ["search", "magnifier", "magnifying-glass", "inspect", "find"],
        defaultCode: 59782,
        grid: 16,
        attrs: []
      },
      attrs: [],
      properties: {
        ligatures: "search, magnifier",
        name: "search",
        order: 6,
        id: 135,
        prevSize: 32
      },
      setIdx: 2,
      setId: 1,
      iconIdx: 134
    },
    {
      icon: {
        paths: [
          "M889.68 166.32c-93.608-102.216-228.154-166.32-377.68-166.32-282.77 0-512 229.23-512" +
            " 512h96c0-229.75 186.25-416 416-416 123.020 0 233.542 53.418 309.696 138.306l-149.696 " +
            "149.694h352v-352l-134.32 134.32z",
          "M928 512c0 229.75-186.25 416-416 416-123.020 0-233.542-53.418-309.694-138.306l149.694-149.694h-" +
            "352v352l134.32-134.32c93.608 102.216 228.154 166.32 377.68 166.32 282.77 0 512-229.23 512-512h-96z"
        ],
        tags: ["loop", "repeat", "player", "reload", "refresh", "update", "synchronize", "arrows"],
        defaultCode: 59950,
        grid: 16,
        attrs: []
      },
      attrs: [],
      properties: {
        ligatures: "loop2, repeat2",
        name: "loop",
        order: 4,
        id: 303,
        prevSize: 32
      },
      setIdx: 2,
      setId: 1,
      iconIdx: 302
    },
    {
      icon: {
        paths: ["M214 768h596v86h-596v-86zM810 384l-298 298-298-298h170v-256h256v256h170z"],
        attrs: [{}],
        isMulticolor: false,
        isMulticolor2: false,
        tags: ["file_download", "download", "get_app"],
        grid: 24
      },
      attrs: [{}],
      properties: {
        order: 1,
        id: 0,
        prevSize: 24,
        name: "download"
      },
      setIdx: 0,
      setId: 4,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M563.2 512l-117.862-128.307c-10.035-10.138-10.035-26.573 0-36.762 10.035-10.086 26.368-10.086 36.352 " +
            "0l143.718 146.637c10.035 10.189 10.035 26.624 0 36.71l-143.718 146.637c-9.984 10.189-26.317 " +
            "10.138-36.352 0-10.035-10.086-10.035-26.522 0-36.71l117.862-128.205zM512 20.48c271.462 0 491.52 " +
            "220.058 491.52 491.52 0 271.514-220.058 491.52-491.52 491.52s-491.52-220.006-491.52-491.52c0-271.462 " +
            "220.058-491.52 491.52-491.52zM512 939.725c236.186 0 427.725-191.488 427.725-427.725s-191." +
            "539-427.725-427.725-427.725c-236.288 0-427.725 191.488-427.725 427.725-0.051 236.237 191.437 " +
            "427.725 427.725 427.725z"
        ],
        attrs: [{}],
        isMulticolor: false,
        isMulticolor2: false,
        tags: ["chevron-with-circle-right"],
        grid: 20
      },
      attrs: [{}],
      properties: {
        order: 1,
        id: 2,
        prevSize: 20,
        name: "circle-right"
      },
      setIdx: 1,
      setId: 3,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M578.662 346.931c-10.035-10.086-26.368-10.086-36.352 0l-143.718 146.688c-10.035 10.189-10.035 " +
            "26.624 0 36.71l143.718 146.637c9.984 10.189 26.317 10.138 36.352 0 10.035-10.086 10.035-26.522 " +
            "0-36.71l-117.862-128.256 117.862-128.307c10.035-10.138 10.035-26.522 0-36.762zM512 20.48c-271.462 " +
            "0-491.52 220.058-491.52 491.52 0 271.514 220.058 491.52 491.52 491.52s491.52-220.006" +
            " 491.52-491.52c0-271.462-220.058-491.52-491.52-491.52zM512 939.725c-236.288" +
            " 0-427.725-191.488-427.725-427.725s191.437-427.725 427.725-427.725c236.186 0 427.725 191.488" +
            " 427.725 427.725s-191.539 427.725-427.725 427.725z"
        ],
        attrs: [{}],
        isMulticolor: false,
        isMulticolor2: false,
        tags: ["chevron-with-circle-left"],
        grid: 20
      },
      attrs: [{}],
      properties: {
        order: 2,
        id: 1,
        prevSize: 20,
        name: "circle-left"
      },
      setIdx: 1,
      setId: 3,
      iconIdx: 1
    },
    {
      icon: {
        paths: ["M256 896v-768h128v352l320-320v704l-320-320v352z"],
        tags: ["previous", "player"],
        defaultCode: 59939,
        grid: 16,
        attrs: []
      },
      attrs: [],
      properties: {
        ligatures: "previous2, player15",
        name: "previous",
        order: 3,
        id: 292,
        prevSize: 32
      },
      setIdx: 3,
      setId: 1,
      iconIdx: 291
    },
    {
      icon: {
        paths: ["M768 128v768h-128v-352l-320 320v-704l320 320v-352z"],
        tags: ["next", "player"],
        defaultCode: 59940,
        grid: 16,
        attrs: []
      },
      attrs: [],
      properties: {
        ligatures: "next2, player16",
        name: "next",
        order: 4,
        id: 293,
        prevSize: 32
      },
      setIdx: 3,
      setId: 1,
      iconIdx: 292
    },
    {
      icon: {
        paths: [
          "M864 0c88.364 0 160 71.634 160 160 0 36.020-11.91 69.258-32 96l-64 64-224-224 64-64c26.742-20.090 " +
            "59.978-32 96-32zM64 736l-64 288 288-64 592-592-224-224-592 592zM715.578 363.578l-448 448-55.156-55.156 " +
            "448-448 55.156 55.156z"
        ],
        tags: ["pencil", "write", "edit"],
        defaultCode: 59653,
        grid: 16,
        attrs: []
      },
      attrs: [],
      properties: {
        ligatures: "pencil, write",
        name: "edit",
        order: 5,
        id: 6,
        prevSize: 32
      },
      setIdx: 3,
      setId: 1,
      iconIdx: 5
    },
    {
      icon: {
        paths: [
          "M192 1024h640l64-704h-768zM640 128v-128h-256v128h-320v192l64-64h768l64 64v-192h-320zM576 " +
            "128h-128v-64h128v64z"
        ],
        tags: ["bin", "trashcan", "remove", "delete", "recycle", "dispose"],
        defaultCode: 59821,
        grid: 16,
        attrs: []
      },
      attrs: [],
      properties: {
        ligatures: "bin2, trashcan2",
        name: "delete",
        order: 6,
        id: 174,
        prevSize: 32
      },
      setIdx: 3,
      setId: 1,
      iconIdx: 173
    },
    {
      icon: {
        paths: [
          "M0 1024h1535.919v-170.315h-1535.919zM0 597.32h1535.919v-170.315h-1535.919zM0 0v170.315h1535.919v-170.315z"
        ],
        attrs: [
          {
            fill: "rgb(74, 74, 74)"
          }
        ],
        width: 1536,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ["Burger"],
        colorPermutations: {
          "10310310311281281281174181188117717717717474741": [
            {
              f: 0
            }
          ]
        }
      },
      attrs: [
        {
          fill: "rgb(74, 74, 74)"
        }
      ],
      properties: {
        order: 35,
        id: 0,
        name: "burger",
        prevSize: 32,
        code: 59664
      },
      setIdx: 0,
      setId: 4,
      iconIdx: 16
    },
    {
      icon: {
        paths: ["M0 0l1024 1024 1024-1024z"],
        attrs: [],
        width: 2048,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ["Drop down arrow"],
        colorPermutations: {
          "10310310311281281281174181188117717717717474741": []
        }
      },
      attrs: [],
      properties: {
        order: 32,
        id: 3,
        name: "drop-down-arrow",
        prevSize: 32,
        code: 59661
      },
      setIdx: 0,
      setId: 4,
      iconIdx: 13
    },
    {
      icon: {
        paths: [
          "M52.966 1024c-26.483 0-52.966-26.483-52.966-52.966v-105.931c0-141.241 114.759-256 256-256h414.897c141.241 " +
            "0 256 114.759 256 256v105.931c0 26.483-26.483 52.966-52.966 " +
            "52.966s-52.966-26.483-52.966-52.966v-105.931c0-79.448-70.621-150.069-150.069-150.069h-414.897c-79.448 " +
            "0-150.069 70.621-150.069 150.069v105.931c-0 35.31-26.483 52.966-52.966 52.966z",
          "M459.034 512c-141.241 0-256-114.759-256-256s114.759-256 256-256c141.241 0 256 114.759 256 256v0c8.828 " +
            "141.241-105.931 256-256 256zM459.034 105.931c-88.276 0-150.069 70.621-150.069 150.069s70.621 150.069 " +
            "150.069 150.069c79.448 0 " +
            "150.069-70.621 150.069-150.069v0c0-44.138-17.655-79.448-44.138-105.931s-61.793-44.138-105.931-44.138z"
        ],
        attrs: [],
        width: 927,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ["Login user icon"],
        colorPermutations: {
          "10310310311281281281174181188117717717717474741": []
        }
      },
      attrs: [],
      properties: {
        order: 27,
        id: 8,
        name: "login-user-icon",
        prevSize: 32,
        code: 59656
      },
      setIdx: 0,
      setId: 4,
      iconIdx: 8
    },
    {
      icon: {
        paths: [
          "M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512c282.77 0 512-229.23 " +
            "512-512v0c0-282.77-229.23-512-512-512v0zM512 153.6c84.831 0 153.6 68.769 " +
            "153.6 153.6s-68.769 153.6-153.6 153.6c-84.831 0-153.6-68.769-153.6-153.6v0c0-84.831 " +
            "68.769-153.6 153.6-153.6v0zM512 880.64c-0 0-0.001 0-0.002 0-127.681 " +
            "0-240.201-64.912-306.36-163.536l-0.839-1.328c1.536-101.888 204.8-157.696 307.2-157.696s305.664 " +
            "55.808 307.2 157.696c-66.997 99.952-179.517 164.864-307.198 164.864-0.001 0-0.001-0-0.002-0l0 0z"
        ],
        attrs: [{}],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ["view account icon"],
        colorPermutations: {
          "10310310311281281281174181188117717717717474741": [{}]
        }
      },
      attrs: [{}],
      properties: {
        order: 28,
        id: 7,
        name: "view-account-icon",
        prevSize: 32,
        code: 59657
      },
      setIdx: 0,
      setId: 4,
      iconIdx: 9
    },
    {
      icon: {
        paths: [
          "M0 512c-0.002 0.153-0.003 0.334-0.003 0.515 0 27.994 22.694 50.688 50.688 50.688 0.181 0 0.362-0.001 0." +
            "542-0.003l-0.028 0h388.608l-117.76 117.248c-4.779 4.666-8.597 10.292-11.147 16.569l-0.117 0.327c-2.59 " +
            "5.726-4.098 12.415-4.098 19.456s1.509 13.73 4.221 19.761l-0.123-0.305c5.369 12.808 15.352 22.791 27.819" +
            " 28.033l0.341 0.127c5.726 2.59 12.415 4.098 19.456 4.098s13.73-1.509 19.761-4.221l-0.305 0.123c6.603-2." +
            "668 12.229-6.487 16.887-11.255l0.009-0.009 204.8-204.8c4.375-4.802 7.993-10.39 10.606-16.511l0.146-0.38" +
            "5c2.429-5.752 3.841-12.439 3.841-19.456s-1.412-13.704-3.966-19.793l0.126 0.337c-2.759-6.506-6.377-12.09" +
            "4-10.794-16.943l0.042 0.047-204.8-204.8c-4.667-4.777-10.293-8.596-16.569-11.147l-0.327-0.117c-5.774-2" +
            ".272-12.461-3.589-19.456-3.589s-13.682 1.317-19.827 3.717l0.371-0.128c-12.808 5.369-22.791 15.352-28." +
            "033 27.819l-0.127 0.341c-2.268 5.775-3.582 12.462-3.582 19.456s1.314 13.681 3.71 19.828l-0.128-0.372c2" +
            ".667 6.604 6.485 12.23 11.254 16.887l0.010 0.009 117.76 117.248h-388.608c-0.153-0.002-0.334-0.003-0.51" +
            "5-0.003-27.994 0-50.688 22.694-50.688 50.688 0 0.181 0.001 0.362 0.003 0.542l-0-0.028zM665.6 0h-512c-" +
            "84.831 0-153.6 68.769-153.6 153.6v0 153.6c0 28.277 22.923 51.2 51.2 51.2s51.2-22.923 51.2-51.2v0-153." +
            "6c-0.002-0.153-0.003-0.334-0.003-0.515 0-27.994 22.694-50.688 50.688-50.688 0.181 0 0.362 0.001 0.542 " +
            "0.003l-0.028-0h512c0.153-0.002 0.334-0.003 0.515-0.003 27.994 0 50.688 22.694 50.688 50.688 0 0.181-0." +
            "001 0.362-0.003 0.542l0-0.028v716.8c0.002 0.153 0.003 0.334 0.003 0.515 0 27.994-22.694 50.688-50.688 5" +
            "0.688-0.181 0-0.362-0.001-0.542-0.003l0.028 0h-512c-0.153 0.002-0.334 0.003-0.515 0.003-27.994 0-50.68" +
            "8-22.694-50.688-50.688 0-0.181 0.001-0.362 0.003-0.542l-0 0.028v-153.6c0-28.277-22.923-51.2-51.2-51.2s" +
            "-51.2 22.923-51.2 51.2v0 153.6c0 84.831 68.769 153.6 153.6 153.6v0h512c84.831 0 153.6-68.769 153.6-153" +
            ".6v0-716.8c0-84.831-68.769-153.6-153.6-153.6v0z"
        ],
        attrs: [
          {
            fill: "rgb(109, 132, 155)"
          }
        ],
        width: 819,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ["log out icon"],
        colorPermutations: {
          "1091321551136217111125514292125548831": [
            {
              f: 0
            }
          ]
        }
      },
      attrs: [
        {
          fill: "rgb(109, 132, 155)"
        }
      ],
      properties: {
        order: 20,
        id: 3,
        name: "log-out-icon",
        prevSize: 32
      },
      setIdx: 0,
      setId: 27,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M1024.128 102.451l-102.451-102.451-409.805 409.805-409.805-409.805-102.451 102.451 " +
            "409.805 409.805-409.805 409.805 102.451 102.451 " +
            "409.805-409.805 409.805 409.805 102.451-102.451-409.805-409.805z"
        ],
        attrs: [
          {
            fill: "rgb(255, 255, 255)"
          }
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ["close icon"],
        colorPermutations: {
          "10310310311281281281174181188117717717717474741": [
            {
              f: 1
            }
          ]
        }
      },
      attrs: [
        {
          fill: "rgb(255, 255, 255)"
        }
      ],
      properties: {
        order: 19,
        id: 16,
        name: "close-icon",
        prevSize: 32,
        code: 59648
      },
      setIdx: 0,
      setId: 4,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M895.808 715.418l677.293-677.805c23.151-23.144 55.129-37.458 90.451-37.458s67.3 14.314 " +
            "90.451 37.458l-0-0c23.297 23.176 37.714 55.258 37.714 90.707s-14.418 " +
            "67.531-37.709 90.701l-0.005 0.005-767.616 767.616c-23.134 23.047-55.047 " +
            "37.296-90.288 37.296-33.285 0-63.602-12.711-86.36-33.545l0.096 " +
            "0.087-772.734-771.966c-17.698-21.769-28.416-49.83-28.416-80.396 0-70.657 " +
            "57.279-127.936 127.936-127.936 31.013 0 59.448 11.035 81.594 29.392l-0.212-0.171z"
        ],
        attrs: [],
        width: 1791,
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ["header arrow icon"],
        colorPermutations: {
          "10310310311281281281174181188117717717717474741": []
        }
      },
      attrs: [],
      properties: {
        order: 30,
        id: 5,
        name: "header-arrow-icon",
        prevSize: 32,
        code: 59659
      },
      setIdx: 0,
      setId: 4,
      iconIdx: 11
    },
    {
      icon: {
        paths: [
          "M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512c282.77 0 512-229.23 512-512v0c-0.25-282.669-229.33-511.75-511.976-512l-0.024-0zM64.658 512c-0-0.238-0.001-0.52-0.001-0.802 0-117.344 45.531-224.053 119.89-303.425l-0.227 0.245c5.355 2.509 9.968 5.389 14.188 8.742l-0.145-0.111c2.396 8.349 3.773 17.939 3.773 27.85 0 6.547-0.601 12.954-1.751 19.168l0.099-0.645v2.121c5.070 12.573 8.012 27.152 8.012 42.418 0 14.171-2.535 27.75-7.175 40.308l0.261-0.806c-8.62 19.031-13.643 41.266-13.643 64.673 0 18.128 3.013 35.553 8.565 51.8l-0.335-1.127c8.631 11.849 50.688 66.853 57.125 73.143 7.623 14.042 14.573 30.465 19.939 47.588l0.541 2.003c12.567 20.682 33.547 35.181 58.071 38.785l0.444 0.054c18.432 0.962 35.402 6.439 50.067 15.336l-0.477-0.268c3.792 2.089 8.416 4.252 13.181 6.136l0.863 0.301c1.097 0 3.218 3.218 4.315 6.437 5.98 11.371 14.817 20.537 25.575 26.747l0.318 0.169c4.971 2.25 9.22 4.692 13.204 7.486l-0.258-0.171c14.386 7.142 26.761 15.026 38.199 24.046l-0.457-0.348c0 1.097-3.218 4.315-5.413 7.314-12.776 11.595-20.767 28.265-20.767 46.802 0 2.115 0.104 4.206 0.307 6.268l-0.021-0.261c14.121 34.552 37.566 62.872 67.218 82.605l0.659 0.412c9.728 6.437 5.413 74.386 0 87.333-1.655 3.978-2.617 8.598-2.617 13.443 0 2.098 0.18 4.154 0.526 6.153l-0.031-0.213h-5.778c-246.333-1.572-445.504-201.257-446.244-447.636l-0-0.071zM601.454 950.857c5.413-6.437 11.849-12.946 12.946-15.067s5.413-3.218 7.314-5.413c7.301-3.357 13.435-8.109 18.291-13.959l0.068-0.084c7.688-10.349 16.567-19.229 26.577-26.675l0.34-0.242c24.067-18.009 45.235-37.484 64.282-58.888l0.376-0.431c6.854-17.719 15.579-33.033 26.21-46.8l-0.317 0.427c11.849-9.728 1.097-26.917-3.218-33.426l-1.097-1.097c-4.315-7.314-34.523-10.752-38.839-9.728-12.604-3.695-23.455-10.028-32.372-18.398l0.042 0.039c0-8.631-24.795-32.329-31.232-32.329-10.301-1.074-19.323-5.834-25.867-12.919l-0.025-0.028c-15.263-11.458-34.134-18.905-54.65-20.459l-0.353-0.021c-12.046-0.052-23.527-2.411-34.044-6.657l0.618 0.22c-8.631-4.315-23.698 2.121-38.839 8.631-2.778 0.747-5.212 1.85-7.414 3.279l0.1-0.061c-14.795-0.477-28.813-3.117-41.971-7.614l1.011 0.3c-2.079-4.999-3.287-10.805-3.287-16.894 0-0.876 0.025-1.745 0.074-2.609l-0.005 0.12c-0.446-5.672-1.198-10.824-2.261-15.861l0.14 0.794c-2.121-4.315-8.631-5.413-22.601-9.728-4.022-1.109-7.258-2.207-10.416-3.459l0.688 0.241c1.069-2.304 2.162-5.165 3.077-8.104l0.141-0.526c4.315-10.752 7.314-18.359 5.413-22.601-1.097-2.121-2.121-3.218-4.315-3.218-6.437-1.097-16.165 5.413-25.893 11.849-3.72 2.842-7.946 5.692-12.335 8.295l-0.611 0.335c-11.864-2.124-22.391-6.664-31.473-13.108l0.241 0.162c-7.314-4.315 1.097-31.232 5.413-43.081 1.839-4.038 3.334-8.746 4.255-13.656l0.060-0.387c0-3.218 15.067-7.314 36.571-7.314 8.096-0.53 15.519-1.492 22.788-2.888l-1.137 0.182c5.305-1.034 11.613-1.791 18.037-2.108l0.322-0.013c3.218 0 8.631 8.631 11.849 12.946 5.413 8.631 9.728 14.043 16.165 12.946 8.631-2.121 7.314-12.946 7.314-20.48v-6.51c4.416-11.283 11.437-20.726 20.353-27.914l0.127-0.099c10.752-6.437 24.795-26.917 21.577-36.571 0-4.315 18.359-17.262 24.795-21.577 2.629-1.477 4.851-2.929 6.971-4.509l-0.169 0.121c2.484-1.118 4.612-2.567 6.445-4.323l-0.008 0.008c8.507-2.624 14.656-10.233 15.066-19.337l0.002-0.046c0-6.437 20.48-9.728 32.329-11.849 3.218 0 5.413-1.097 7.314-1.097 5.591-0.056 10.594-2.526 14.026-6.416l0.018-0.021c0.421-1.511 0.663-3.246 0.663-5.037 0-3.705-1.036-7.168-2.833-10.116l0.049 0.086c-1.097-1.097-1.097-3.218-2.121-5.413-1.393-2.416-2.215-5.313-2.215-8.402 0-6.677 3.839-12.456 9.431-15.252l0.099-0.045c5.046-2.795 11.063-4.44 17.465-4.44 1.061 0 2.112 0.045 3.15 0.134l-0.135-0.009c9.535-0.843 18.329-2.76 26.67-5.647l-0.777 0.234c5.090-1.15 9.112-4.833 10.722-9.625l0.030-0.103c0.026-0.36 0.041-0.779 0.041-1.202 0-5.040-2.089-9.591-5.448-12.837l-0.005-0.005c-1.097-2.121-2.121-3.218-3.218-5.413-4.771-7.519-10.498-13.921-17.113-19.267l-0.148-0.116c-3.218-2.121-5.413-15.067-7.314-22.601-0.722-4.465-1.842-8.449-3.354-12.235l0.136 0.386c-1.097-3.218-3.218-4.315-6.437-5.413-1.652-0.258-3.557-0.406-5.496-0.406-6.683 0-12.957 1.751-18.389 4.818l0.187-0.097c0-1.097-1.097-4.315-1.097-5.413-0.307-4.487-1.88-8.554-4.359-11.911l0.044 0.062c-2.991-3.024-6.164-5.85-9.509-8.466l-0.219-0.165c-6.437-5.413-14.043-12.946-19.383-18.359-1.978-2.008-4.727-3.253-7.766-3.253-0.304 0-0.606 0.012-0.904 0.037l0.039-0.003c-7.314 1.097-14.043 9.728-19.383 19.383-1.097 1.097-1.097 2.121-2.121 3.218-9.728 14.043-10.752 24.795-4.315 30.208 0.147 0.66 0.231 1.417 0.231 2.194 0 1.88-0.493 3.645-1.356 5.173l0.027-0.053c-3.218 7.314-7.314 12.946-10.752 12.946v0c-8.631-1.097-10.752 10.752-12.946 22.601-0.963 5.145-2.077 9.497-3.438 13.738l0.219-0.792c-2.121-2.121-4.315-8.631-4.315-28.014v-1.902c-0.235-2.405-0.993-4.593-2.159-6.504l0.038 0.067c-2.21-1.411-4.904-2.249-7.794-2.249-0.682 0-1.353 0.047-2.010 0.137l0.076-0.009c-4.315 0-6.437 0-7.314-1.097-10.492-9.221-23.131-16.274-37.052-20.309l-0.689-0.171v-28.014c14.183-11.738 30.064-22.46 46.946-31.566l1.548-0.763c18.32-9.115 33.839-18.427 48.564-28.793l-1.167 0.779c3.28-1.46 5.526-4.69 5.526-8.445 0-0.873-0.121-1.718-0.348-2.518l0.016 0.065c-1.097-9.728-18.359-16.165-25.893-18.359-5.413-12.946-14.043-12.946-24.795-12.946-0.653 0.013-1.422 0.020-2.193 0.020-5.702 0-11.309-0.406-16.793-1.191l0.628 0.074c-14.215-2.662-30.57-4.185-47.28-4.185-8.023 0-15.964 0.351-23.808 1.039l1.017-0.072c-2.935 0.273-6.347 0.429-9.796 0.429-11.506 0-22.606-1.734-33.055-4.955l0.794 0.211c-6.437-1.097-11.849-2.121-17.262-3.218h-8.485c49.547-21.138 107.189-33.427 167.702-33.427 0.185 0 0.37 0 0.556 0l-0.029-0c0.472-0.002 1.030-0.003 1.589-0.003 60.953 0 118.939 12.701 171.456 35.602l-2.768-1.075c1.484 6.937 3.705 13.072 6.634 18.782l-0.197-0.423c7.99 14.997 13.37 32.557 15.030 51.186l0.038 0.526c0.536 5.971 0.842 12.915 0.842 19.931s-0.306 13.961-0.905 20.822l0.063-0.89c-2.121 5.413 33.426 43.886 40.96 45.275s12.946-4.315 17.262-11.849c7.241-10.449 15.81-19.345 25.599-26.705l0.294-0.211c13.883-6.653 30.16-10.602 47.345-10.752l0.052-0c15.706 15.741 29.889 33.013 42.301 51.571l0.78 1.238c-3.218 3.218-7.314 5.413-9.728 7.314-6.437 6.437-24.795 24.795-22.601 37.742 5.471 17.802 17.948 32.022 34.132 39.696l0.391 0.167c11.53 6.116 19.478 17.644 20.473 31.106l0.007 0.126c0 3.218 25.893 19.383 25.893 19.383s-10.752 21.577-16.165 21.577-9.728 21.577-9.728 30.208c3.255 13.457 10.923 24.766 21.356 32.589l0.148 0.106c10.752 8.631 29.257-15.067 29.257-15.067l3.218-1.097 3.218 42.057c-14.956 2.293-28.389 7.224-40.382 14.328l0.519-0.284c-7.314 6.437-23.698 58.514-31.232 63.561-10.327 24.214-18.577 52.466-23.404 81.871l-0.294 2.17c9.088 25.964 21.482 48.454 36.976 68.419l-0.405-0.542c-63.803 111.593-170.927 192.238-297.873 219.481l-2.963 0.533z"
        ],
        attrs: [
          {
            fill: "rgb(255, 255, 255)",
            opacity: 0.8
          }
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ["Path 14937"]
      },
      attrs: [
        {
          fill: "rgb(255, 255, 255)",
          opacity: 0.8
        }
      ],
      properties: {
        order: 12,
        id: 21,
        name: "language-bar-icon",
        prevSize: 32
      },
      setIdx: 13,
      setId: 4,
      iconIdx: 0
    },
    {
      icon: {
        paths: [
          "M512.037 0c-282.79-0-512.037 229.247-512.037 512.037s229.247 512.037 512.037 512.037c282.79 0 512.037-229.247 512.037-512.037v0c0-0.044 0-0.097 0-0.15 0-282.708-229.18-511.888-511.888-511.888-0.052 0-0.105 0-0.157 0l0.008-0zM512.037 198.186c100.292 0.043 181.577 81.355 181.577 181.652 0 100.324-81.328 181.652-181.652 181.652s-181.652-81.328-181.652-181.652l0 0c-0-100.324 81.328-181.652 181.652-181.652 0.026 0 0.053 0 0.079 0l-0.004-0zM512.037 908.41c-121.132-0.044-229.532-54.52-302.074-140.295l-0.48-0.582c39.206-73.773 115.477-123.207 203.315-123.446l0.033-0c0.022-0 0.049-0 0.075-0 5.314 0 10.436 0.821 15.246 2.342l-0.358-0.098c25.156 8.74 54.158 13.921 84.329 14.214l0.138 0.001c30.229-0.362 59.116-5.593 86.080-14.942l-1.913 0.577c4.453-1.424 9.575-2.245 14.888-2.245 0.026 0 0.053 0 0.079 0l-0.004-0c87.872 0.239 164.143 49.673 202.745 122.203l0.604 1.243c-73.047 86.261-181.423 140.653-302.504 140.653-0.070 0-0.14-0-0.21-0l0.010 0z"
        ],
        attrs: [
          {
            fill: "rgb(255, 255, 255)",
            opacity: 0.8
          }
        ],
        isMulticolor: false,
        isMulticolor2: false,
        grid: 0,
        tags: ["Icon awesome-user-circle"]
      },
      attrs: [
        {
          fill: "rgb(255, 255, 255)",
          opacity: 0.8
        }
      ],
      properties: {
        order: 13,
        id: 22,
        name: "user-bar-icon",
        prevSize: 32
      },
      setIdx: 13,
      setId: 4,
      iconIdx: 0
    }
  ],
  height: 1024,
  preferences: {
    showGlyphs: true,
    showQuickUse: true,
    showQuickUse2: true,
    showSVGs: true,
    fontPref: {
      prefix: "icon-",
      metadata: {
        fontFamily: "icomoon"
      },
      metrics: {
        emSize: 1024,
        baseline: 6.25,
        whitespace: 50
      },
      embed: false
    },
    imagePref: {
      prefix: "icon-",
      png: true,
      useClassSelector: true,
      color: 0,
      bgColor: 16777215,
      classSelector: ".icon",
      name: "icomoon"
    },
    historySize: 50,
    showCodes: true,
    gridSize: 16
  }
};

export default iconSet;
